import lodash from 'lodash';

// const Entities = require('html-entities').AllHtmlEntities;
// const entities = new Entities();

export default {
  format: (textFormat, value = []) => {
    var formatted = textFormat || '';
    for (var i = 0; i < value.length; i++) {
      formatted = formatted.replace('%s', value[i]);
    }
    return formatted;
  },
  removeLineBreak(text) {
    const result = text.replace(/[\r\n]+/gm, '');
    return result.trim();
  },
  removeDoubleSpace(str) {
    return str.replace(/\s{2,}/g, ' ');
  },
  replaceUnicode: (str) => {
    if (str === null || str === undefined) return str;
    // str = str.toLowerCase();
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
    str = str.replace(/đ/g, 'd');
    str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, 'A');
    str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, 'E');
    str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, 'I');
    str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, 'O');
    str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, 'U');
    str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, 'Y');
    str = str.replace(/Đ/g, 'D');
    return str;
  },

  replaceSignUnicode: (str) => {
    if (str === null || str === undefined) return str;
    str = str.toLowerCase();
    str = str.replace(/à|á|ạ|ả|ã/g, 'a');
    str = str.replace(/ầ|ấ|ậ|ẩ|ẫ/g, 'â');
    str = str.replace(/ằ|ắ|ặ|ẳ|ẵ/g, 'ă');
    str = str.replace(/è|é|ẹ|ẻ|ẽ/g, 'e');
    str = str.replace(/ề|ế|ệ|ể|ễ/g, 'ê');
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
    str = str.replace(/ò|ó|ọ|ỏ|õ/g, 'o');
    str = str.replace(/ồ|ố|ộ|ổ|ỗ/g, 'ô');
    str = str.replace(/ờ|ớ|ợ|ở|ỡ/g, 'ơ');
    str = str.replace(/ù|ú|ụ|ủ|ũ/g, 'u');
    str = str.replace(/ừ|ứ|ự|ử|ữ/g, 'ư');
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
    return str;
  },

  replaceAll: (str, from, to) => {
    return str.replace(new RegExp(from, 'g'), to);
  },

  toCamelCase: (str) => {
    return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
  },

  decodeCamelCase: (str) => {
    return str.replace(/([A-Z]+)/g, ' $1').replace(/([A-Z][a-z])/g, ' $1');
  },

  capitalize: (str) => {
    return lodash.capitalize(str);
  },

  capitalizeAll: (str) => {
    return lodash.startCase(lodash.toLower(str));
  },

  upperCase: (str) => {
    return str.toUpperCase();
  },

  getFileNameFromPath: (path = '') => {
    try {
      return path.split('/').reverse()[0];
    } catch (err) {
      return path;
    }
  }

  // decodeEntities: (str) => entities.decode(str)
};
